import { RECEIVER_INFO, SENDER_INFO } from "../../constants";
import { UserInfo } from "./userInfo";
import styles from "./styles.module.scss";
import React from "react";
import classNames from "classnames";

export const ReceiverInfo = (props: any) => {
  const renderUserId = props?.renderUserId;
  const returnTitle = () => {
    return props.receiverType == "receiver" ? RECEIVER_INFO : SENDER_INFO;
  };

  return (
    <div className={classNames(styles.infoContainer, styles.pointer)}>
      <h4>{returnTitle()}</h4>
      <div className={styles["user_container"]}>
        <div>
          <UserInfo
            renderUserId={renderUserId}
            type={props.receiverType}
            contractStatus={props.contractStatus}
          />
        </div>
      </div>
    </div>
  );
};
